export const SRC_LIGHTBOX_OPEN = 'SRC_LIGHTBOX_OPEN'
export const SRC_LIGHTBOX_CLOSE = 'SRC_LIGHTBOX_CLOSE'

function open(src) {
  return {
    type: SRC_LIGHTBOX_OPEN,
    src,
  }
}

function close() {
  return {
    type: SRC_LIGHTBOX_CLOSE,
  }
}

export function openSrcLightbox(src) {
  return (dispatch) => {
    dispatch(open(src))
  }
}

export function closeSrcLightbox() {
  return (dispatch) => {
    dispatch(close())
  }
}
